import TextField from '@eversports/react-components/primitives/TextField'
import React from 'react'

import { Localized } from '../../../localization/react'

const PhoneNumber: React.FC<React.PropsWithChildren<unknown>> = () => (
  <TextField
    id="phoneNumber"
    key="phoneNumber"
    name="phoneNumber"
    label={<Localized id="field-phone-number" />}
    fullWidth
    required
    data-testid="required-information-phone-number"
  />
)

export default PhoneNumber
